import { Loader } from '../Loader';
import React, { useMemo } from 'react';
import '../../css/LatestVideos.css';
import { Video } from '../../interfaces/userInterfaces';
import { VideoDisplay } from './VideoViews/VideoDisplayOG';
import { usePublicData } from '../../hooks/usePublicData';

export const LatestVideos: React.FC = () => {
  const { latestVideos, loadReady } = usePublicData();

  const mapVideoArray = (videos: Video[]) => {
    return videos.map((video, i) => {
      return (
        <div
          key={video.username + i + video.video_id}
          className="latest-video-list"
          role="video-grid-element"
        >
          <VideoDisplay {...video} />
        </div>
      );
    });
  };

  const memoizedVidArray = useMemo(() => mapVideoArray(latestVideos), [latestVideos]);

  return (
    <>
      <Loader />
      <div className="latest-videos" style={{ display: loadReady ? 'grid' : 'none' }}>
        {memoizedVidArray}
      </div>
    </>
  );
};
